export const labelArray = [
    {
        name : 'availabilityselections',
        value: 'Availability Selections',
    },
    {
        name: 'specialevents',
        value: 'Special Events',
    },
    {
        name: 'details',
        value: 'Details',
    },
    {
        name: 'accommodation',
        value: 'Accommodations',
    },
    {
        name: 'Addaccomodation',
        value: 'Add Accomodation',
    },
    {
        name: 'controls',
        value: 'Controls',  
    },
    {
        name: 'specialeventscontrols',
        value: 'Special Events Controls',
    },
    {
        name: 'eventcontrols',
        value: 'Event Controls',
    },
    {
        name: 'searchevent',
        value: 'Event Location Controls',
    },
    {
        name: 'EventDetails',
        value: 'Event Details',
    },
    {
        name: 'availabilityapplicationcontrols',
        value: 'Availability Controls',
    },
    {
        name: 'apponoff',
        value: 'Application On/Off',
    },
    {
        name: 'workschedulegrouping',
        value: 'Work Schedule Grouping',
    },
    {
        name: 'rules',
        value: 'Rules',
    },
    {
        name: 'advancesearch',
        value: 'Advance Search',
    },
    {
        name: 'ruleassignments',
        value: 'Rule Assignments',
    },
    {
        name: 'cutoffcalendar',
        value: 'Cutoff Calendar'
    },
    {
        name: 'locationcontrols',
        value: 'Location Controls',
    },
    {
        name: 'bulkadd',
        value: 'Bulk Add',
    },





]